module.exports = __webpack_public_path__ + "static/img/GAES_SINGLE.d9f34ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logos/GAES_SINGLE.png
// module id = 733
// module chunks = 6